/*

 HTML STRUCTURE:

 <div class="tabs" id="one-univoque-id">
   <div class="tabs__navigation">
     <div class="tabs__navigation__item tabs__navigation__item--active">first tab label</div>
     <div class="tabs__navigation__item">second tab label</div>
   </div>
   <div class="tabs_items">
     <div class="tabs__tab">
        first tab content
     </div>
     <div class="tabs__tab">
        second tab content
     </div>
   </div>
 </div>

 SCSS: _c_tabs.scss

*/
export default class Tabs {

  constructor(options){
    this.wrapper = document.querySelector(`#${options.wrapperId}`);
    this.navigation = this.wrapper.querySelector('.tabs__navigation');
    this.scrollwrapper = this.wrapper.querySelector('.tabs__navigation__scrollwrapper');
    this.triggers = this.wrapper.querySelectorAll('.tabs__navigation__item');
    this.arrows = this.wrapper.querySelectorAll('.tabs__navigation__arrow');
    this.tabs = this.wrapper.querySelectorAll('.tabs__tab');

    this.activeClassTrigger = 'tabs__navigation__item--active';
    this.hiddenClassArrow = 'tabs__navigation__arrow--hidden';
    this.activeClassTab = 'tabs__tab--active';
    this.hiddenClassTab = 'tabs__tab--hidden';

    this.currentTab = 0;

    this.selectTab(this.currentTab);
    this.initClick();
  }

  initClick(){
    this.triggers.forEach((elem, index) => {
      elem.addEventListener('click', () => {
        this.selectTab(index);
      });
    });

    this.arrows.forEach(a => {
      const direction = a.dataset.direction;
      a.addEventListener('click', () => {
        this.handleArrowClick(direction);
      })
    });
  }

  getTriggerWidth() {
    return this.triggers[0].offsetWidth;
  }

  scrollToTrigger(idx) {
    const tw = this.getTriggerWidth();
    const scrollAmt = idx * tw - tw/2;
    console.log('scroll to trigger', idx, tw, scrollAmt);
    console.log(this.scrollwrapper);
    this.scrollwrapper.scroll(scrollAmt, 0);
  }

  selectTab(current){
    // update current
    const nTriggers = this.triggers.length - 1;
    this.current = Math.max(0, Math.min(current, nTriggers));

    // set triggers activation
    this.triggers.forEach((elem, i) => {
      this.triggers[i].classList.remove(this.activeClassTrigger);
    });
    this.triggers[this.current].classList.add(this.activeClassTrigger);
    this.scrollToTrigger(this.current);

    // set tabs activation
    this.tabs.forEach((elem, i) => {
      this.tabs[i].classList.remove(this.activeClassTab);
      this.tabs[i].classList.add(this.hiddenClassTab);
    });
    this.tabs[this.current].classList.add(this.activeClassTab);
    this.tabs[this.current].classList.remove(this.hiddenClassTab);

    // hide/show arrows
    this.arrows.forEach(a => {
      const dir = a.dataset.direction;
      if (
        (dir === "<" && this.current === 0) ||
        (dir === ">" && this.current === nTriggers)
      ) {
        a.classList.add(this.hiddenClassArrow);
      } else {
        a.classList.remove(this.hiddenClassArrow);
      }
    }); 
  }

  handleArrowClick(direction) {
    let idx = this.current;
    if (direction === "<") idx--;
    if (direction === ">") idx++;
    console.log(direction, this.current, idx)
    this.selectTab(idx);
  }
}
